import React from 'react';
export function NewTrustedDeviceTemplate() {
  return <div style={{
    fontFamily: 'Arial, sans-serif',
    maxWidth: '600px',
    margin: '0 auto'
  }} data-id="element-494">
      {/* Header with logo */}
      <div style={{
      textAlign: 'center',
      padding: '32px 0'
    }} data-id="element-495">
        <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/hnodgoqduyba7n8dlqxg6c/d4d40573-a6d5-4127-bafb-e288840a0b5f/AISCO_WORKSPACE_MARCA_POSITIVO.svg" alt="Aisco Workspace" style={{
        height: '40px',
        display: 'inline-block'
      }} data-id="element-496" />
      </div>

      {/* Main content */}
      <div style={{
      backgroundColor: '#ffffff',
      padding: '40px 32px'
    }} data-id="element-497">
        <h1 style={{
        fontSize: '24px',
        fontWeight: '600',
        color: '#1f2937',
        marginBottom: '16px',
        marginTop: '0'
      }} data-id="element-498">
          New trusted device added
        </h1>

        <p style={{
        fontSize: '16px',
        color: '#4b5563',
        lineHeight: '1.6',
        marginBottom: '24px'
      }} data-id="element-499">
          Hello,
        </p>

        <p style={{
        fontSize: '16px',
        color: '#4b5563',
        lineHeight: '1.6',
        marginBottom: '32px'
      }} data-id="element-500">
          A new device has been marked as trusted on your Aisco Workspace
          account. You won't receive security alerts for sign-ins from this
          device in the future.
        </p>

        <div style={{
        backgroundColor: '#f0fdf4',
        padding: '20px',
        borderRadius: '8px',
        borderLeft: '4px solid #10b981',
        marginBottom: '32px'
      }} data-id="element-501">
          <h3 style={{
          fontSize: '16px',
          fontWeight: '600',
          color: '#065f46',
          marginTop: '0',
          marginBottom: '12px'
        }} data-id="element-502">
            ✓ Trusted Device Added
          </h3>
          <p style={{
          margin: '0',
          color: '#047857',
          fontSize: '14px',
          lineHeight: '1.6'
        }} data-id="element-503">
            This device will now be recognized for future sign-ins, providing
            you with a smoother login experience.
          </p>
        </div>

        <div style={{
        backgroundColor: '#f9fafb',
        padding: '20px',
        borderRadius: '8px',
        border: '1px solid #e5e7eb',
        marginBottom: '32px'
      }} data-id="element-504">
          <h3 style={{
          fontSize: '14px',
          fontWeight: '600',
          color: '#6b7280',
          marginTop: '0',
          marginBottom: '12px',
          textTransform: 'uppercase',
          letterSpacing: '0.5px'
        }} data-id="element-505">
            Device Details
          </h3>
          <div style={{
          display: 'grid',
          gap: '8px'
        }} data-id="element-506">
            <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '14px',
            lineHeight: '1.6'
          }} data-id="element-507">
              <span style={{
              color: '#6b7280'
            }} data-id="element-508">
                Device:
              </span>
              <span style={{
              color: '#1f2937',
              fontWeight: '500'
            }} data-id="element-509">
                Chrome on macOS
              </span>
            </div>
            <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '14px',
            lineHeight: '1.6'
          }} data-id="element-510">
              <span style={{
              color: '#6b7280'
            }} data-id="element-511">
                Location:
              </span>
              <span style={{
              color: '#1f2937',
              fontWeight: '500'
            }} data-id="element-512">
                Madrid, Spain
              </span>
            </div>
            <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '14px',
            lineHeight: '1.6'
          }} data-id="element-513">
              <span style={{
              color: '#6b7280'
            }} data-id="element-514">
                Added:
              </span>
              <span style={{
              color: '#1f2937',
              fontWeight: '500'
            }} data-id="element-515">
                January 15, 2025 at 10:30 AM
              </span>
            </div>
          </div>
        </div>

        <div style={{
        backgroundColor: '#fef3c7',
        padding: '20px',
        borderRadius: '8px',
        borderLeft: '4px solid #f59e0b',
        marginBottom: '32px'
      }} data-id="element-516">
          <p style={{
          margin: '0',
          color: '#92400e',
          fontSize: '14px',
          lineHeight: '1.6'
        }} data-id="element-517">
            <strong data-id="element-518">Didn't add this device?</strong> If you don't recognize this
            device, remove it immediately and change your password to secure
            your account.
          </p>
        </div>

        {/* CTA Button */}
        <div style={{
        textAlign: 'center',
        margin: '32px 0'
      }} data-id="element-519">
          <a href="#" style={{
          display: 'inline-block',
          backgroundColor: '#2563eb',
          color: '#ffffff',
          padding: '14px 32px',
          borderRadius: '8px',
          textDecoration: 'none',
          fontSize: '16px',
          fontWeight: '600'
        }} data-id="element-520">
            Manage trusted devices
          </a>
        </div>

        <p style={{
        fontSize: '14px',
        color: '#6b7280',
        lineHeight: '1.6',
        marginTop: '32px',
        marginBottom: '0',
        textAlign: 'center'
      }} data-id="element-521">
          You can remove trusted devices at any time from your account settings.
        </p>
      </div>

      {/* Footer */}
      <div style={{
      backgroundColor: '#f9fafb',
      padding: '24px 32px',
      borderTop: '1px solid #e5e7eb',
      textAlign: 'center'
    }} data-id="element-522">
        <p style={{
        fontSize: '12px',
        color: '#6b7280',
        lineHeight: '1.5',
        margin: '0'
      }} data-id="element-523">
          Aisco Europe S.A.U • Calle Playa de Riazor 22, 28042
          <br data-id="element-524" />
          Madrid, Spain
        </p>
      </div>
    </div>;
}